module.exports = __webpack_public_path__ + "dd8f7f8631d7739edfffeba814695e22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/hochformat/10.jpg
// module id = 147
// module chunks = 0